<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_navigator') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
            span(slot="value") {{ parameters.difficult + ' x ' + parameters.difficult }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
            span(slot="value") {{ parameters.numOfExamples }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_portal') }}
            span(slot="value") {{ parameters.portal === 0 ? $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') : parameters.portal }}
        game-preview-setting
            span(slot="name")  {{ $i18n.t('trainer.trainer_gameFormSetting_field') }}
            span(slot="value") {{ parameters.isFieldOpened ? $i18n.t('trainer.trainer_gameFormSettingValue_opened') : $i18n.t('trainer.trainer_gameFormSettingValue_closed')}}
        game-preview-setting
            span(slot="name")  {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfSteps') }}
            span(slot="value") {{ parameters.amountOfSteps }}
        game-preview-setting
            span(slot="name")  {{ $i18n.t('trainer.trainer_gameFormSetting_speed') }}
            span(slot="value") {{ parameters.speed }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
    }
</script>
